<template>
    <div class="listing-info">
        <el-button type="primary" size="small" @click="handleAddListing">添加匹配</el-button>
        <el-table :data="listingData" border style="margin-top: 20px;">
            <el-table-column label="图片" width="100">
                <template slot-scope="scope">
                    <el-image :src="scope.row.mainImage" :preview-src-list="[scope.row.mainImage]"></el-image>
                </template>
            </el-table-column>
            <el-table-column label="平台SKU" prop="sku" width="180"></el-table-column>
            <el-table-column label="ASIN" prop="asin" width="120"></el-table-column>
            <el-table-column label="标题" prop="itemName"></el-table-column>
            <el-table-column label="店铺" prop="shopName" width="180"></el-table-column>
            <el-table-column label="国家" prop="countryName" width="80"></el-table-column>
            <el-table-column prop="status" label="状态" width="60" align="center">
                <template slot-scope="scope">
                    <div :class="scope.row.status === '在售' ? 'green-box' : 'red-box'">
                        <span>{{ scope.row.status }}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="80">
                <template slot-scope="scope">
                    <el-button type="text" @click="handleDelete(scope.row)">解除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div style="height: 50px"></div>
        <div class="block float-box">
            <el-pagination
                @size-change="handleOutSizeChange"
                @current-change="handleOutCurrentChange"
                :current-page="outPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="outSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="outTotal">
            </el-pagination>
        </div>

        <!-- Listing匹配弹窗 -->
        <el-dialog title="Listing匹配" :visible.sync="dialogVisible" width="70%" top="5vh" append-to-body>
            <div class="search-bar">
                <el-select v-model="searchType" placeholder="请选择">
                    <el-option label="sku" value="sku"></el-option>
                    <el-option label="asin" value="asin"></el-option>
                    <el-option label="标题" value="itemName"></el-option>
                </el-select>
                <el-input v-model="searchStr" @input="searchStr = searchStr.trim()" placeholder="请输入" clearable style="width: 200px;margin-right: 20px;"></el-input>
                <el-button type="primary" @click="handleAddListing">搜索</el-button>
            </div>
            <el-table :data="searchResults" border @selection-change="handleSelectionChange" max-height="560px">
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column label="图片" width="100">
                    <template slot-scope="scope">
                        <el-image :src="scope.row.mainImage" :preview-src-list="[scope.row.mainImage]"></el-image>
                    </template>
                </el-table-column>
                <el-table-column label="平台SKU" prop="sku" width="180"></el-table-column>
                <el-table-column label="ASIN" prop="asin" width="120"></el-table-column>
                <el-table-column label="标题" prop="itemName"></el-table-column>
                <el-table-column label="店铺" prop="shopName" width="180"></el-table-column>
                <el-table-column label="国家" prop="countryName" width="80"></el-table-column>
                <el-table-column prop="status" label="状态" width="60" align="center">
                    <template slot-scope="scope">
                        <div :class="scope.row.status === '在售' ? 'green-box' : 'red-box'">
                            <span>{{ scope.row.status }}</span>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="block">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="handleConfirmMatch">确定匹配</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { ajaxPost, Baseurl } from '@/api/api/api'
export default {
    name: 'ListingInfo',
    props: {
        formData: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            listingData: [],
            dialogVisible: false,
            searchResults: [],
            selectedItems: [],
            page: 1,
            size: 10,
            total: 0,
            searchType: 'sku',
            searchStr: '',
            outPage: 1,
            outSize: 10,
            outTotal: 0,
        }
    },
    created(){
        this.getPairedListings()
    },
    computed: {
        userInfo(){
            return JSON.parse(localStorage.getItem('role'))
        }
    },
    methods: {
        getRowStatus(status){
            let arr = [];
            try {
                arr = JSON.parse(status);
            } catch (error) {
                
            }
            if(arr.includes("BUYABLE")){
                return '在售';
            }
            return '停售';
        },
        handleSizeChange(val) {
            this.page = 1;
            this.size = val;
            this.handleAddListing();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.handleAddListing();
        },
        handleOutSizeChange(val) {
            this.outPage = 1;
            this.outSize = val;
            this.getPairedListings();
        },
        handleOutCurrentChange(val) {
            this.outPage = val;
            this.getPairedListings();
        },
        // 获取已配对的数据
        async getPairedListings(){
            const params = {
                id: this.formData.id,
                page: this.outPage,
                size: this.outSize,
            }
            const res = await ajaxPost(Baseurl + '/productController/selectPairedListings', params);
            if(res.data.code === 200){
                let list = res.data.data.list || [];
                list = list.map(item => {   
                    item.status = this.getRowStatus(item.status);
                    return item;
                });
                this.listingData = list;
                this.outTotal = res.data.data.total || 0;
            }
        },
        // 获取未配对的数据
        async handleAddListing() {
            try {
                this.$loading({
                    lock: true,
                    text: '加载中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                const params = {
                    rid: this.userInfo.rid,
                    page: this.page,
                    size: this.size,
                }
                if(this.searchType){
                    params.searchType = this.searchType;
                }
                if(this.searchStr){
                    params.searchStr = this.searchStr;
                }

                const res = await ajaxPost(Baseurl + '/amazonProductOnline/selectNotPairedAmazonProductOnlines', params);
                if (res.data.code === 200) {
                    let list = res.data.data.list || [];
                    list = list.map(item => {   
                        item.status = this.getRowStatus(item.status);
                        return item;
                    });
                    this.searchResults = list;
                    this.total = res.data.data.total || 0;
                    this.dialogVisible = true;
                } else {
                    this.$message.error(res.data.data || '获取数据失败！');
                }
            } catch (error) {
                this.$message.error('获取数据失败！');
            } finally {
                this.$loading().close();
            }
        },
        async handleDelete(row) {
            // 处理解除匹配
            const params = {
                productId: this.formData.id,
                listingId: row.id
            }
            const res = await ajaxPost(Baseurl + '/productListingPair/unpairProductListing', params);
            if(res.data.code === 200){
                this.$message.success('解除匹配成功！');
                this.getPairedListings();
            } else {
                this.$message.error(res.data.data || '解除匹配失败！');
            }
        },
        async handleSearch() {
            try {
                this.$loading({
                    lock: true,
                    text: '搜索中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });

                const res = await ajaxPost(Baseurl + 'amazonProductListing/selectAmazonProductListingPage', {
                    page: 1,
                    size: 10,
                    searchStr: this.searchStr,
                    searchType: ''
                });

                if (res.data.code === 200) {
                    this.searchResults = res.data.data.list || [];
                } else {
                    this.$message.error(res.data.data || '搜索失败！');
                }
            } catch (error) {
                this.$message.error('搜索失败！');
            } finally {
                this.$loading().close();
            }
        },
        handleSelectionChange(val) {
            this.selectedItems = val;
        },
        async handleConfirmMatch() {
            if (this.selectedItems.length === 0) {
                this.$message.warning('请选择要匹配的项!');
                return;
            }
            const listingIds = this.selectedItems.map(item => item.id);
            const res = await ajaxPost(Baseurl + '/productController/pairListing', {
                listingIds: listingIds,
                id: this.formData.id,
                platform: "amazon"
            });
            if (res.data.code === 200) {
                this.$message.success('匹配成功！');
                this.getPairedListings();
            } else {
                this.$message.error(res.data.data || '搜索失败！');
            }
            // TODO: 处理确认匹配的逻辑
            this.dialogVisible = false;
        }
    }
}
</script>

<style lang="css" scoped>
.green-box {
    color: #67c23a;
    font-weight: bold;
}

.red-box {
    color: #f56c6c;
    font-weight: bold;
}
.block{
    display: flex;
    justify-content: center;
    margin-top: 10px;
}
.search-bar{
    margin-bottom: 10px;
}
.float-box{
    position: absolute;
    bottom: 5px;
    left: 50%;
    transform: translateX(-50%);
    background: #fff;
    padding: 10px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    margin: 0;
    z-index: 1000;
}
</style>